import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import Icon from 'dpl/common/components/Icon';
import NotificationCount from 'dpl/common/components/NotificationCount';
import useCurrentUser from 'dpl/common/hooks/useCurrentUser';
import { FancyDropdownMenuItem } from 'dpl/components/FancyDropdown';
import SmartLink from 'dpl/components/SmartLink';
import {
  BREEDER_CENTER_PATH,
  BREEDER_DASHBOARD_PATH,
  BREEDER_DOWNLOADS_PATH,
  BREEDER_EDIT_PROFILE_PATH,
  BREEDER_REFERRAL_LINKS_PATH,
  BREEDER_SETTINGS_ACCOUNT_PATH,
  HELP_BREEDERS_PATH,
  ROOT_HOST
} from 'dpl/shared/constants/urls';

export default function UserHeaderLoggedInBreederMenu({
  totalNotificationsCount,
  profilePath,
  isPublished
}) {
  const { pathname } = window.location;
  const currentUser = useCurrentUser();

  const menuLinks = useMemo(
    () =>
      [
        {
          id: 'dashboard',
          label: 'Dashboard',
          iconName: 'fetch-dashboard',
          path: BREEDER_DASHBOARD_PATH,
          notificationCount: totalNotificationsCount
        },
        {
          id: 'edit-profile',
          label: 'Edit profile',
          iconName: 'fetch-edit-alt',
          path: BREEDER_EDIT_PROFILE_PATH
        },
        {
          id: 'view-profile',
          label: 'View profile',
          iconName: 'fetch-view',
          path: profilePath
        },
        currentUser.value.data.published && {
          id: 'referral-links',
          label: 'Referral links',
          iconName: 'fetch-link',
          path: BREEDER_REFERRAL_LINKS_PATH
        },
        {
          id: 'settings',
          label: 'Settings',
          iconName: 'fetch-settings',
          path: BREEDER_SETTINGS_ACCOUNT_PATH
        },
        isPublished && {
          id: 'downloads',
          label: 'Downloads',
          iconName: 'fetch-download',
          path: BREEDER_DOWNLOADS_PATH
        },
        {
          id: 'breeder-center',
          label: 'Good Breeder Center',
          iconName: 'fetch-gbc',
          path: BREEDER_CENTER_PATH
        },
        {
          id: 'help',
          label: 'Help',
          iconName: 'fetch-help',
          path: HELP_BREEDERS_PATH
        }
      ].filter(Boolean),
    [totalNotificationsCount, profilePath, isPublished]
  );

  return (
    <>
      {menuLinks.map(
        ({ id, label, iconName, path, onClick, notificationCount }) => (
          <FancyDropdownMenuItem key={id} itemKey={id}>
            <SmartLink
              to={path ? `${ROOT_HOST}${path}` : null}
              onClick={onClick}
              className={classnames(
                'flex items-center gap-12 w-100 pv2 ph3 nowrap font-16 fw-medium transition',
                pathname.startsWith(path) ? 'stone-700' : 'secondary'
              )}
            >
              <Icon
                className="tertiary"
                name={iconName}
                height="24px"
                width="24px"
              />
              <span className="flex-auto flex gap-8">{label}</span>
              {Boolean(notificationCount) && (
                <NotificationCount
                  count={notificationCount}
                  unreadColor="stone-700"
                />
              )}
            </SmartLink>
          </FancyDropdownMenuItem>
        )
      )}
    </>
  );
}

UserHeaderLoggedInBreederMenu.propTypes = {
  profilePath: PropTypes.string.isRequired,
  isPublished: PropTypes.bool.isRequired,
  totalNotificationsCount: PropTypes.number.isRequired
};
